"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import AutoComplete from "src/decidim/refactor/moved/autocomplete";
const autoConfigure = (el) => {
  const config = JSON.parse(el.dataset.autocomplete);
  const searchUrl = new URL(config.searchURL);
  const textInput = document.createElement("input");
  textInput.type = "text";
  textInput.className = "autocomplete-input";
  el.appendChild(textInput);
  let mode = config.mode || "sticky";
  let selected = null;
  if (config.selected) {
    switch (mode) {
      case "multi":
        selected = config.selected.map((item) => ({
          key: "label",
          value: {
            value: item.value,
            label: item.label
          }
        }));
        break;
      case "sticky":
        selected = { key: "label", value: config.options[config.options.length - 1] };
        break;
      default:
        selected = config.selected;
    }
  }
  const dataSource = (query, callback) => {
    const params = new URLSearchParams(__spreadProps(__spreadValues({}, Object.fromEntries(searchUrl.searchParams)), {
      term: query
    }));
    fetch(`${searchUrl.origin}${searchUrl.pathname}?${params.toString()}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" }
    }).then((response) => response.json()).then((data) => {
      callback(data);
    });
  };
  const ac = new AutoComplete(textInput, {
    name: config.name,
    placeholder: config.placeholder,
    selected,
    mode,
    searchPrompt: true,
    searchPromptText: config.searchPromptText,
    threshold: 3,
    dataMatchKeys: ["label"],
    dataSource
  });
  return ac;
};
document.addEventListener("turbo:load", () => {
  const $autocompleteDiv = $("[data-autocomplete]");
  if ($autocompleteDiv.length < 1) {
    return;
  }
  $autocompleteDiv.each((_index, element) => {
    autoConfigure(element);
  });
});
